export enum CompanyStatusEnum {
    Deleted,
    Enabled,
    Disabled
}
